import { all } from 'redux-saga/effects';
import activityLogs from './activity-logs';

export const activityLogSaga = function* root() {
  yield all([activityLogs()]);
};
